export const USER_BOARD = "gym-owners/auth/user-board";
export const ADMIN_BOARD = "admin/auth/dashboard";



// WEBPACK FOOTER //
// ./src/app/shared/values.ts